import React from 'react';

/** Bloc de l'Observatoire : titre, légende, et le graphique ou tableau en dessous. */
export const Bloc = ({ titre, legende, pleineLargeur = false, testid, children, enTeteDroite }) => (
  <section
    data-testid={testid}
    className={`bg-white rounded-xl border border-slate-200 p-4 md:p-5 min-w-0 ${
      pleineLargeur ? 'lg:col-span-2' : ''
    }`}
  >
    <div className="flex items-start justify-between gap-3 mb-1">
      <h2 className="text-base md:text-lg font-bold text-slate-900">{titre}</h2>
      {enTeteDroite}
    </div>
    {legende && <p className="text-xs text-slate-500 mb-3">{legende}</p>}
    {children}
  </section>
);

export default Bloc;
